import { RefreshCw, TrendingUp } from 'lucide-react'
import { useCallback, useEffect, useRef, useState } from 'react'
import EmptyState from '../components/EmptyState.jsx'
import ErrorState from '../components/ErrorState.jsx'
import LoadingState from '../components/LoadingState.jsx'
import Pagination from '../components/Pagination.jsx'
import RepoCard from '../components/RepoCard.jsx'

const PAGE_SIZE = 10

function RankingPage({
  eyebrow,
  title,
  description,
  loadRanking,
  emptyTitle,
  rankingLabel = '综合热度排序',
  rankingIcon = <TrendingUp size={17} />,
}) {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [page, setPage] = useState(1)
  const listAnchorRef = useRef(null)

  const load = useCallback((signal) => {
    setLoading(true)
    setError('')
    loadRanking(page, PAGE_SIZE, signal)
      .then(setData)
      .catch((requestError) => {
        if (requestError.name !== 'AbortError') setError(requestError.message)
      })
      .finally(() => setLoading(false))
  }, [loadRanking, page])

  useEffect(() => {
    const controller = new AbortController()
    load(controller.signal)
    return () => controller.abort()
  }, [load])

  const updateFavorite = (repoId, isFavorited) => {
    setData((current) => ({
      ...current,
      items: current.items.map((item) => (
        item.id === repoId ? { ...item, isFavorited } : item
      )),
    }))
  }

  const handlePageChange = (nextPage) => {
    setPage(nextPage)
    requestAnimationFrame(() => {
      listAnchorRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    })
  }

  return (
    <div className="page-container">
      <section className="page-heading compact-heading">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{description}</p>
        </div>
      </section>

      <div className="ranking-list-anchor" ref={listAnchorRef}>
        <div className="ranking-strip">
          <span>{rankingIcon} {rankingLabel}</span>
          <span>{data?.pagination?.total ?? data?.items?.length ?? 0} 个项目</span>
        </div>
      </div>

      {loading && <LoadingState label={`正在读取${title}`} />}
      {!loading && error && <ErrorState message={error} onRetry={() => load()} />}
      {!loading && !error && data?.items?.length === 0 && (
        <EmptyState
          icon={<RefreshCw size={28} />}
          title={emptyTitle}
          message={data?.message || '暂无已发布的榜单数据。'}
        />
      )}
      {!loading && !error && data?.items?.length > 0 && (
        <>
          <div className="repo-list">
            {data.items.map((repo) => (
              <RepoCard
                key={repo.id}
                repo={repo}
                onFavoriteChange={updateFavorite}
              />
            ))}
          </div>
          <Pagination
            pagination={data.pagination}
            onPageChange={handlePageChange}
            disabled={loading}
          />
        </>
      )}
    </div>
  )
}

export default RankingPage
